
import React from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { VideoFilterOptions } from '@/hooks/useVideoEvents';

interface ContentTypeFiltersProps {
  localFilters: VideoFilterOptions;
  handleContentTypeChange: (type: string, checked: boolean) => void;
}

const ContentTypeFilters: React.FC<ContentTypeFiltersProps> = ({
  localFilters,
  handleContentTypeChange,
}) => {
  return (
    <div>
      <h3 className="font-medium mb-2">Type de contenu</h3>
      <div className="grid grid-cols-2 gap-2">
        <div className="flex items-center space-x-2">
          <Checkbox 
            id="video" 
            checked={localFilters.contentTypes?.includes('video')}
            onCheckedChange={(checked) => handleContentTypeChange('video', checked === true)}
          />
          <Label htmlFor="video">Vidéo</Label>
        </div>
        <div className="flex items-center space-x-2">
          <Checkbox 
            id="short" 
            checked={localFilters.contentTypes?.includes('short')}
            onCheckedChange={(checked) => handleContentTypeChange('short', checked === true)}
          />
          <Label htmlFor="short">Short</Label>
        </div>
        <div className="flex items-center space-x-2">
          <Checkbox 
            id="live" 
            checked={localFilters.contentTypes?.includes('live')}
            onCheckedChange={(checked) => handleContentTypeChange('live', checked === true)}
          />
          <Label htmlFor="live">Live</Label>
        </div>
      </div>
    </div>
  );
};

export default ContentTypeFilters;
